/** Locale-aware "22 Jul 2026, 12:39" formatting for value-history timestamps. */
export function formatHistoryDate(iso: string, language: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(language === "et" ? "et-EE" : "en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
